var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"h4",class:{ 'badges-cell': _vm.displayColumn }},[_vm._l((_vm.items),function(item){return [(item.active)?_c('b-badge',{key:item.label,staticClass:"mr-1 mb-1",attrs:{"variant":"light"}},[_vm._v(" "+_vm._s(item.label)+" ")]):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }